// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"94":"Login","231":"Meal Plan","274":"Home","827":"Signup"}[chunkId] || chunkId) + "." + {"38":"80b9e10f","94":"0643ebfc","229":"384adea3","231":"76ae72dd","274":"5032d46e","827":"58126091"}[chunkId] + ".chunk.css";
};